import { render, staticRenderFns } from "./list-sortable.vue?vue&type=template&id=8f80e05c&scoped=true&"
import script from "./list-sortable.vue?vue&type=script&lang=js&"
export * from "./list-sortable.vue?vue&type=script&lang=js&"
import style0 from "./list-sortable.vue?vue&type=style&index=0&id=8f80e05c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f80e05c",
  null
  
)

export default component.exports